import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider, PrivateRoute } from "@cakrawalajakarta/shared-components";
import { Layout } from "./components/Layout";
import { MidtransScript } from "@cakrawalajakarta/shared-components";

import Beranda from "./Beranda";

// Dynamic imports untuk komponen besar
const Berita = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Berita })));
const TentangKami = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.TentangKami })));
const Kontak = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Kontak })));
const Profile = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Profile })));
const Login = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Login })));
const Register = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Register })));
const Actions = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Actions })));
const Verify = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Verify })));
const LupaPassword = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.LupaPassword })));
const Sukses = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Sukses })));
const DetailBerita = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.DetailBerita })));
const AddNews = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.AddNews })));
const SyaratKetentuan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.SyaratKetentuan })));
const KebijakanPrivasi = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.KebijakanPrivasi })));
const Kegiatan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Kegiatan })));
const KegiatanDetail = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.KegiatanDetail })));
const SuratPernyataan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.SuratPernyataan })));
const FormPendaftaran = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.FormPendaftaran })));
const FormPendaftaranSeminar = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.FormPendaftaranSeminar })));
const PesananSaya = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.PesananSaya })));
const EntryList = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.EntryList })));
const Xtrifeinnie = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Xtrifeinnie })));
const StravaCallback = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.StravaCallback })));
const StravaStats = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.StravaStats })));
const PesananDetail = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.PesananDetail })));
const Sukarelawan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Sukarelawan })));
const Sponsor = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Sponsor })));
const Layanan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Layanan })));
const CariAnggota = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.CariAnggota })));
const DetailAnggota = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.DetailAnggota })));
const VerifyAnggota = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.VerifyAnggota })));
const FormKeanggotaan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.FormKeanggotaan })));
const KartuAkses = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.KartuAkses })));

// Komponen untuk halaman 404
const NotFound = () => (
  <section className="w-full min-h-screen py-20 text-center text-cyan-600 flex-col justify-center relative bg-slate-100">
    <h2 className="text-xl sm:text-2xl md:text-3xl font-normal uppercase mb-2 text-cyan-600">
      HALAMAN
    </h2>
    <p className="text-4xl sm:text-5xl md:text-7xl font-black mx-auto mb-16 text-cyan-600 px-4">
      TIDAK DITEMUKAN
    </p>
    <a href="/" className="text-cyan-600 underline">
      Kembali ke Beranda
    </a>
  </section>
);

// Komponen untuk fallback loading
const LoadingFallback = () => (
  <div className="w-full min-h-screen flex items-center justify-center bg-slate-100">
    <div className="text-center text-cyan-600">
      <p className="text-2xl font-semibold">Memuat...</p>
    </div>
  </div>
);

const App = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <MidtransScript />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              {/* Rute Utama */}
              <Route index element={<Beranda />} />
              <Route path="Berita" element={<Berita />} />
                     <Route path="news/:slug" element={<DetailBerita />} />
              <Route path="Kegiatan" element={<Kegiatan />} />
              <Route path="kegiatan/:slug" element={<KegiatanDetail />} />
              <Route path="Tentangkami" element={<TentangKami />} />
              <Route path="Kontak" element={<Kontak />} />
              <Route path="SyaratKetentuan" element={<SyaratKetentuan />} />
              <Route path="KebijakanPrivasi" element={<KebijakanPrivasi />} />

              {/* Rute Autentikasi */}
              <Route path="Login" element={<Login />} />
              <Route path="Register" element={<Register />} />
              <Route path="Verify" element={<Verify />} />
              <Route path="LupaPassword" element={<LupaPassword />} />

              {/* Rute Terkait Pengguna */}
              <Route
                path="Profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route path="PesananSaya" element={<PesananSaya />} />
              <Route path="/pesanan-detail" element={<PesananDetail />} />
              <Route path="form/:slug" element={<FormPendaftaran />} />
              <Route path="formseminar/:slug" element={<FormPendaftaranSeminar />} />
              <Route path="Sukses" element={<Sukses />} />
              <Route path="SuratPernyataan" element={<SuratPernyataan />} />
              <Route path="Sukarelawan" element={<Sukarelawan />} />
              <Route path="Sponsor" element={<Sponsor />} />
              <Route path="Layanan" element={<Layanan />} />
              <Route path="KartuAkses" element={<KartuAkses />} />

              {/* Rute Khusus */}
              <Route
                path="Xtrifeinnie"
                element={
                  <PrivateRoute>
                    <Xtrifeinnie />
                  </PrivateRoute>
                }
              />
              <Route path="strava-callback" element={<StravaCallback />} />
              <Route
                path="strava-stats"
                element={
                  <PrivateRoute>
                    <StravaStats />
                  </PrivateRoute>
                }
              />
              <Route path="entrylist/:eventId" element={<EntryList />} />
              <Route path="Actions" element={<Actions />} />
              <Route path="AddNews" element={<AddNews />} />
              <Route path="/DetailAnggota/:memberId" element={<DetailAnggota />} />
              <Route path="/CariAnggota" element={<CariAnggota />} />
              <Route path="/VerifyAnggota/:memberId" element={<VerifyAnggota />} />
              <Route path="form/membership" element={<FormKeanggotaan />} />

              {/* Rute 404 */}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;